import styled from 'styled-components'
import Link from '../../../../utils/Link'

const MessageLink = styled(Link)`
  display: block;
  border-top: 1px solid #d2d2d2;
  padding: 15px 0;
  overflow: hidden;
  &:hover {
    text-decoration: none;
  }
`

const SenderContainer = styled.div`
  color: #777;
  display: flex;
  display: -ms-flexbox;
  justify-content: space-between;
  margin-bottom: 4px;
`

const Sender = styled.div`
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  background: ${props => props.attachment > 0 ? `url('${STATICS_PATH}images/email/clip-icon.png') top right no-repeat` : ''};
  ${MessageLink}:hover & {
    color: #444;
  }
`

const MessageDate = styled.div`
  font-size: 13px;
  color: #777;
  ${MessageLink}:hover & {
    color: #333;
  }
`

const Subject = styled.div`
  color: ${props => props.read ? '#333' : props.theme.email.full.subject.color};
  font-weight: ${props => props.read ? 'normal' : 'bold'};
  ${MessageLink}:hover & {
    color: ${props => props.theme.email.full.subject.colorHover};
    text-decoration: underline;
  }
`

export { MessageDate, MessageLink, Sender, SenderContainer, Subject }
